import React from 'react'
import Footer from './Footer'
export default function Terms() {
  return (
    <div>
    <div className='container p-4 shadow-3-soft mt-2'>
        <h4>Declaration</h4>
        <p>I hereby state that I have no objection and give my consent in sharing my bank details with Suvico Solution Private Limited.  I also understand that Suvico will use this information only for the purpose of registration of e-NACH mandate.</p>
        
    </div>  <Footer/> </div>
  )
}
